import React from 'react';
interface ICloseXIconProps {
  style?: React.CSSProperties;
  color?: string;
}

export const CloseXIcon = ({ style, color = '#898989' }: ICloseXIconProps) => {
  return (
    <div style={{ cursor: 'pointer', display: 'flex', ...style }}>
      <svg width="8" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line
          x1="1.13042"
          y1="1.66211"
          x2="8.66162"
          y2="9.19331"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="1.13042"
          y1="1.66211"
          x2="8.66162"
          y2="9.19331"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="1.13042"
          y1="1.66211"
          x2="8.66162"
          y2="9.19331"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="1.13042"
          y1="1.66211"
          x2="8.66162"
          y2="9.19331"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="8.66162"
          y1="1.7066"
          x2="1.13042"
          y2="9.2378"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="8.66162"
          y1="1.7066"
          x2="1.13042"
          y2="9.2378"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="8.66162"
          y1="1.7066"
          x2="1.13042"
          y2="9.2378"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
        <line
          x1="8.66162"
          y1="1.7066"
          x2="1.13042"
          y2="9.2378"
          stroke={color}
          strokeWidth="1.54825"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
